import { Component } from '@angular/core';
import { ModalController, NavParams } from '@ionic/angular';
import { Store } from '@ngrx/store';

import * as rootReducer from '../../../../../core/store';
import * as fromHistoryAction from '../../../../../inbox/inbox-deliveries/store/inbox.actions';
import { Delivery, InboxDelivery } from '../../../../../core/models';

@Component({
  standalone: false,
  selector: 'pptl-modal-reactivate-delivery',
  templateUrl: './modal-reactivate.component.html',
  styleUrls: ['./modal-reactivate.component.scss'],
})
export class ModalReactivateComponent {
  private delivery: InboxDelivery | Delivery;

  constructor(
    public modalController: ModalController,
    private store: Store<rootReducer.State>,
    public navParams: NavParams,
  ) {
    this.delivery = this.navParams.get('delivery');
  }

  onSubmit() {
    this.store.dispatch(
      fromHistoryAction.reactivateDelivery({
        deliveryId: this.delivery?.deliveryKeyCode,
      }),
    );
    this.modalController.dismiss();
  }

  onCancel() {
    this.modalController.dismiss();
  }
}
